import { render, staticRenderFns } from "./list-item-trilha.vue?vue&type=template&id=5f4662ca"
import script from "./list-item-trilha.vue?vue&type=script&lang=js"
export * from "./list-item-trilha.vue?vue&type=script&lang=js"
import style0 from "./list-item-trilha.vue?vue&type=style&index=0&id=5f4662ca&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports